import axiosInstance from '@/utils/axiosInstance.js'
import SERVICE from '@/utils/servicesUtil.js'

const getOrganization = ($organizationId) => axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}`)
const updateOrganization = ($organizationId, $data) => axiosInstance.put(`${SERVICE.ORGANIZATION}/${$organizationId}`, $data)
const getOrganizationTypes = ($organizationId) => axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/items/types`)
const createOrganization = ($data) => axiosInstance.post(`${SERVICE.ORGANIZATION}`, $data)
const organizationRoot = ($descendantOrganizationId) => axiosInstance.get(`${SERVICE.ORGANIZATION}/${$descendantOrganizationId}/rootorganization`)

const disableOrganization = ($organizationId) => axiosInstance.patch(`${SERVICE.ORGANIZATION}/${$organizationId}/disable`)

const deleteOrganization = ($organizationId) => axiosInstance.delete(`${SERVICE.ORGANIZATION}/${$organizationId}`)

const getSubOrganizations = ($organizationId, $page, $count) =>
  axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/AllDescendents`, { params: { Page: $page, Count: $count } })

const getSubOrganizationsNew = ($organizationId, $page, $count, $companyName, $status) =>
  axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/organizations`, {
    params: { Page: $page, Count: $count, CompanyName: $companyName, Status: $status },
  })

const canCreateOrganization = ($userId) => axiosInstance.get(`/user/api/v1.0/user/cancreateorganization`)

const getOrganizationBalanceTypes = ($organizationId, params) => {
  if ($organizationId) return axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/assignableorganizationbalanceconfigtypesforupdate`)
  else return axiosInstance.get(`${SERVICE.ORGANIZATION}/assignableorganizationbalanceconfigtypesforcreate`, { params: params })
}

const canCreateNewSuborganization = ($organizationId) => axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/cancreatenewsuborganization`)

const getEligibleDestinationOrganizations = ($organizationId, params) =>
  axiosInstance.get(`${SERVICE.ORGANIZATION}/${$organizationId}/geteligibledestinationorganizations`, { params })

const changeParentOrganization = ($organizationId, $body) =>
  axiosInstance.patch(`${SERVICE.ORGANIZATION}/${$organizationId}/changeparentorganization`, $body)

export default {
  getOrganization,
  updateOrganization,
  getOrganizationTypes,
  createOrganization,
  getSubOrganizations,
  disableOrganization,
  deleteOrganization,
  canCreateOrganization,
  getSubOrganizationsNew,
  organizationRoot,
  getOrganizationBalanceTypes,
  canCreateNewSuborganization,
  getEligibleDestinationOrganizations,
  changeParentOrganization,
}
